import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Button } from '@material-ui/core'

import useStyles from './styles'

const FatButton = ({ className, selected = false, children, ...rest }) => {
  const classes = useStyles()

  return (
    <Button
      className={clsx(classes.root, className)}
      variant="contained"
      color="inherit"
      {...rest}
      {...(selected && { variant: 'contained', color: 'primary' })}
    >
      {children}
    </Button>
  )
}

FatButton.propTypes = {
  className: PropTypes.string,
  selected: PropTypes.bool,
  children: PropTypes.node,
}

export default FatButton
